const padLayout = [
  {
    key: "Q",
    sample: "1up",
  },
  {
    key: "W",
    sample: "block",
  },
  {
    key: "E",
    sample: "coin",
  },
  {
    key: "A",
    sample: "death",
  },
  {
    key: "S",
    sample: "jump",
  },
  {
    key: "D",
    sample: "pause",
  },
  {
    key: "Z",
    sample: "pipe",
  },
  {
    key: "X",
    sample: "powerup",
  },
  {
    key: "C",
    sample: "stageclear",
  },
];

export default padLayout;
